import { brandColors, brandFonts } from './styled/brand'

const themeConfig = {
  palette: {
    primary: {
      main: brandColors.coral,
      contrastText: brandColors.creamLight,
      light: brandColors.coralAccentLight,
    },
    secondary: {
      main: brandColors.coralText,
      contrastText: brandColors.cream,
    },
    standout: {
      main: brandColors.nearBlack,
      accent: brandColors.coralAccentLight,
    },
    background: {
      default: brandColors.cream,
      paper: brandColors.creamLight,
      accent: brandColors.creamLight,
      accentdark: brandColors.coral,
    },
    text: {
      primary: brandColors.nearBlack2,
      secondary: brandColors.textMuted,
    },
  },
  typography: {
    fontFamily: brandFonts.body,
    allVariants: {
      color: brandColors.nearBlack2,
    },
    h1: { fontFamily: brandFonts.heading },
    h2: { fontFamily: brandFonts.heading },
    h3: { fontFamily: brandFonts.heading },
    h4: { fontFamily: brandFonts.heading },
    h5: { fontFamily: brandFonts.heading },
    h6: { fontFamily: brandFonts.heading },
  },
}

export default themeConfig
